import { mediaData } from '@/mocks/chiguaHomeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            吃瓜视频
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            51吃瓜视频在线观看专区，热门八卦视频精选
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 group-hover:bg-background-50 transition-colors">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-[11px] rounded font-mono whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors mb-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次观看
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}